module.exports = __webpack_public_path__ + "img/do-not-enter.74c3e01f.svg";